'use strict';

var _ = require('lodash');
var GridDemandPostingButtonController = function GridDemandPostingButtonController($scope, $rootScope, demandPostingContextService, dataRetrieverService, dataRetrieverConstantsService, directForecastingConfigurationService) {
  var gridPanel = $scope.gridPanelScope;
  var gridDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService[gridPanel.screen], gridPanel.mode, gridPanel.target);
  $scope.demandPostingPanel = {
    disabled: true
  };
  $scope.disableDPIcon = function () {
    var filterClassGroups = $scope.demandPostingPanel.filterClassGroups;
    var allRows = $scope.demandPostingPanel.allRows;
    var isDirectForecastEnabled = directForecastingConfigurationService.isDirectForecastEnabled(_.first(allRows));
    var multipleMarkets = _.uniqBy($scope.selectedRows, 'market').length > 1;
    var singleOrNoFilterClassGroup = filterClassGroups && filterClassGroups.length < 2;
    $scope.demandPostingPanel.disabled = isDirectForecastEnabled || multipleMarkets ? true : singleOrNoFilterClassGroup || allRows && allRows.length === 0;
  };
  $scope.$on('brush-filter:filterApplied', function (event, brushSelectionFilter) {
    var filterElements = brushSelectionFilter.filterArguments[0];
    if (brushSelectionFilter.filterType === 'classGroups') {
      $scope.demandPostingPanel.filterClassGroups = filterElements;
      $scope.disableDPIcon();
    }
  });
  $scope.onRowSelection = function (event, selectedRows, gridId, allRows) {
    $scope.demandPostingPanel.allRows = allRows;
    $scope.selectedRows = selectedRows;
    $scope.disableDPIcon();
  };
  $scope.enterDemandPosting = function () {
    $scope.buildDemandPostingContext().then(function (context) {
      $rootScope.$broadcast('demand-posting:swap', true, context);
    });
  };
  $scope.buildDemandPostingContext = function () {
    return gridDataRetriever.retrieveComponentData(gridPanel.gridId).then(function (data) {
      var context = demandPostingContextService.getContext(data);
      context.market = $scope.selectedRows.length > 0 ? _.get($scope.selectedRows[0], 'market') : context.markets[0];
      context.dateRanges = demandPostingContextService.getDateRange(context, gridDataRetriever);
      context.gridParams = {
        screen: gridPanel.screen,
        gridId: gridPanel.gridId,
        target: gridPanel.target,
        mode: gridPanel.mode
      };
      return context;
    });
  };
};
GridDemandPostingButtonController.$inject = ['$scope', '$rootScope', 'DemandPostingContextService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'DirectForecastingConfigurationService'];
module.exports = GridDemandPostingButtonController;